export interface PlanFeature {
  text: string;
  included: boolean;
}

export interface PlanData {
  name: string;
  slug: string;
  priceMonthly: number;
  priceYearly: number;
  description: string;
  features: PlanFeature[];
  recommended: boolean;
}

export const PLANS_DATA: PlanData[] = [
  {
    name: 'Solo',
    slug: 'solo',
    priceMonthly: 49,
    priceYearly: 490,
    description: 'Para profissionais independentes que querem organizar a agenda.',
    features: [
      { text: '1 profissional', included: true },
      { text: '1 administrador', included: true },
      { text: 'Agenda online', included: true },
      { text: 'Gestão de clientes', included: true },
      { text: 'Caixa e comandas', included: true },
      { text: 'Produtos e pacotes', included: true },
      { text: 'Dashboard básico', included: true },
      { text: 'Página pública simples', included: true },
      { text: 'WhatsApp automático', included: true },
      { text: 'IA assistida (500 interações/mês)', included: true },
      { text: 'Comissões', included: false },
      { text: 'Fluxo de caixa', included: false },
      { text: 'Múltiplos administradores', included: false },
    ],
    recommended: false,
  },
  {
    name: 'Studio',
    slug: 'studio',
    priceMonthly: 129,
    priceYearly: 1290,
    description: 'Para barbearias e salões que querem crescer com inteligência.',
    features: [
      { text: 'Até 5 profissionais', included: true },
      { text: 'Até 3 administradores', included: true },
      { text: 'Agenda online', included: true },
      { text: 'Gestão de clientes', included: true },
      { text: 'Caixa e comandas', included: true },
      { text: 'Produtos e pacotes', included: true },
      { text: 'Dashboard avançado', included: true },
      { text: 'Página pública personalizada', included: true },
      { text: 'WhatsApp automático', included: true },
      { text: 'IA operacional (3.000 interações/mês)', included: true },
      { text: 'Comissões', included: true },
      { text: 'Fluxo de caixa', included: true },
      { text: 'Permissões', included: true },
      { text: 'Campanhas automáticas', included: false },
      { text: 'Analytics avançado', included: false },
    ],
    recommended: true,
  },
  {
    name: 'Elite',
    slug: 'elite',
    priceMonthly: 239,
    priceYearly: 2390,
    description: 'Para negócios em expansão que exigem o melhor em gestão.',
    features: [
      { text: 'Até 15 profissionais', included: true },
      { text: 'Até 10 administradores', included: true },
      { text: 'Agenda online', included: true },
      { text: 'Gestão de clientes', included: true },
      { text: 'Caixa e comandas', included: true },
      { text: 'Produtos e pacotes', included: true },
      { text: 'Dashboard avançado', included: true },
      { text: 'Página pública personalizada', included: true },
      { text: 'WhatsApp automático', included: true },
      { text: 'IA avançada (ilimitada)', included: true },
      { text: 'Comissões', included: true },
      { text: 'Fluxo de caixa', included: true },
      { text: 'Permissões', included: true },
      { text: 'Campanhas automáticas (Em breve)', included: true },
      { text: 'Analytics avançado (Em breve)', included: true },
      { text: 'Suporte prioritário', included: true },
    ],
    recommended: false,
  },
];
